import { axios } from '~/clients';
import {
  SEO_CONTENT_CLIENT,
  SEO_LINKS_CLIENT,
  SEO_REVIEWS_CLIENT
} from '~/constants/endpoints';
import type { SeoContent, SeoLinks, SeoReviews } from '~/contracts/Seo';
import { logError, toError } from '~/utilities/errorHandlers';

export const fetchSeoContent = async (
  pathname: string,
  { signal }
): Promise<SeoContent | undefined> => {
  try {
    const { data } = await axios.get<SeoContent>(
      `${SEO_CONTENT_CLIENT}?contentUrl=${pathname}`,
      {
        signal
      }
    );

    return data;
  } catch (error) {
    if (!signal.aborted) {
      logError(toError(error), { location: 'Get SEO Content' });
    }

    return undefined;
  }
};

export const fetchSeoLinks = async (
  pathname: string,
  { signal }
): Promise<SeoLinks | undefined> => {
  try {
    const { data } = await axios.get<SeoLinks>(
      `${SEO_LINKS_CLIENT}${pathname}`,
      {
        signal
      }
    );

    return data;
  } catch (error) {
    if (!signal.aborted) {
      logError(toError(error), { location: 'Get SEO Links' });
    }

    return undefined;
  }
};

export const fetchSeoReviews = async (
  pathname: string,
  { signal }
): Promise<SeoReviews | undefined> => {
  try {
    const { data } = await axios.get<SeoReviews>(
      `${SEO_REVIEWS_CLIENT}?requestUrl=${pathname}`,
      {
        signal
      }
    );

    return data;
  } catch (error) {
    if (!signal.aborted) {
      logError(toError(error), { location: 'Get SEO Reviews' });
    }

    return undefined;
  }
};
